module.exports = __webpack_public_path__ + "media/components/weather-icon/static/nightcloud-987e021dffc572a219863ec8c87cfb8f.svg";